import DoneIcon from "@mui/icons-material/Done";
import React, { RefObject } from "react";
import MenuItemWithIcon, { MenuItemWithIconProps } from "./MenuItemWithIcon";

interface CheckedMenuItemProps extends MenuItemWithIconProps {
	/** indicate if the item is being checked  */
	checked?: boolean;
}

const CheckedMenuItem = React.forwardRef((props: CheckedMenuItemProps, ref: RefObject<HTMLLIElement>) => {
	const {
		checked,
		text,
		...otherProps
	} = props;

	return (
		<MenuItemWithIcon
			ref={ref}
			text={text}
			{...otherProps}
		>
			{checked &&
				<DoneIcon color="action" style={{ fontSize: 16 }} />
			}
		</MenuItemWithIcon>
	);
});

export default CheckedMenuItem;